module.exports = __webpack_public_path__ + "static/img/ebook_index_tow.64c0cb5f.jpg";